module.exports = __webpack_public_path__ + "img/cockft.f90ef28f.png";